import { FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField, Typography, InputAdornment, IconButton } from '@mui/material';
import React from 'react';
import { ChipContainer } from '../../pages/hospital/Request/RequestInfo';
import { orange, red } from '@mui/material/colors';
import { LocalizeContextProps, Translate, withLocalize } from 'react-localize-redux';
import { ColourChip } from './mini_components-ts';
import ClearIcon from '@mui/icons-material/Clear';

export interface FilterItem{
    label:string, 
    value:number, 
    selected:boolean, 
    icon?: JSX.Element, 
    extraFilters?: JSX.Element,
    color:string, callBack:() => void
}

interface SearchBoxProps extends LocalizeContextProps{
    hideSearchPatient?: boolean,
    selectFilter?:{
        value: string;
        icon?: JSX.Element;
        label?: string;
        options :  { value: string; label: string; }[],
        callBack:(value:string) => void;
    }
    extraFilters?: () => JSX.Element,
    filterItems:FilterItem[],
    textField:{
        label:string,
        helperText?:string,
        callBack:(value:string) => void;
    }    
}

const SearchBox: React.FC<SearchBoxProps> = ({ filterItems, selectFilter, extraFilters, translate, hideSearchPatient, textField }) => {
    function getLabel(item:FilterItem){
        const defaultLabel:string = translate(`hospital.search_box.filters.${item.label}`).toString();
        if(defaultLabel.includes("Missing translationId")){
            return translate(item.label);
        }
        else{
            return defaultLabel;
        }
    }
    return (
        <>
            <Grid item xs={12}>
                <Paper elevation={3} style={{paddingTop:"1rem", paddingLeft:"1rem", paddingRight:"1rem", paddingBottom:"0.5rem", marginTop:'1rem'}} >
                    <Grid container spacing={2}>
                        {
                            !hideSearchPatient &&
                            <Grid item xs={12}>
                                <Grid item xs={6}>
                                    <TextField fullWidth onChange={(event) => textField.callBack(event.target.value)} 
                                        helperText={<Translate id={textField.helperText || "hospital.search_box.find_patient.helperText"} />} 
                                        variant="outlined" label={translate(textField.label)} />
                                </Grid>
                            </Grid>
                        }
                        
                        {filterItems.length > 0 && (
                            <Grid item xs={12} container alignItems='center'>
                                <Grid item zeroMinWidth>
                                    <Typography variant="body2" component="span"><Translate id="hospital.search_box.filter" /></Typography>:
                                    {
                                        filterItems.map((item) => {
                                            return(<ChipContainer>
                                                        <ColourChip rgbcolor={item.color} active={!item.selected} 
                                                            avatar={item.icon}
                                                            onClick={item.callBack} label={getLabel(item)}/>
                                                    </ChipContainer>);
                                        })
                                    }
                                </Grid>
                            </Grid>
                        )}
                        
                        {
                            selectFilter &&
                            <Grid item xs={12} container alignItems='center'>
                                <Grid item xs={12} container spacing={2}>
                                    <Grid item xs={3}>
                                        <div>
                                            <FormControl fullWidth variant="outlined" margin="dense"  >
                                                <InputLabel id="provider">{selectFilter.label ? <Translate id={selectFilter.label} /> : "Provider"}</InputLabel>
                                                    <Select
                                                        labelId="provider"
                                                        id="provider"
                                                        value={selectFilter.value}
                                                        onChange={(event) => selectFilter.callBack(event.target.value as string)}
                                                        endAdornment={
                                                            selectFilter.value && (
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            selectFilter.callBack('');
                                                                        }}
                                                                        size="small"
                                                                    >
                                                                        <ClearIcon />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            )
                                                        }
                                                    > 
                                                    { selectFilter.options.map((option) => {
                                                        return <MenuItem value={option.value}>{option.label}</MenuItem>
                                                    }) }
                                                    </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                        {
                            extraFilters &&
                            <Grid item xs={12}>
                                {extraFilters()}
                            </Grid>
                        }
                    </Grid>
                </Paper>
            </Grid>
        </>
    );
};

export default withLocalize(SearchBox);
